module.exports = __webpack_public_path__ + "static/a-xx-005-art-cb43b4217a30584296107a97bf33f1eb.jpg";